import React, { useMemo } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';

// GLOBAL FUNCTIONS
import { checkRole, formatDollar } from 'functions.js';

// REACT COMPONENTS
import { Col, Row } from 'react-bootstrap';

// CORE COMPONENTS
import Form from 'core/form/Form';

// GLOBAL PARTS
import Card from 'parts/card/Card';

// LOCAL VARIABLES
import { IMV_RESULTS_KEYS } from '../../options';

// LOCAL COMPONENTS
import PriceAdjustment from './PriceAdjustment';

// STYLES
import styles from './imvResults.module.scss';

const IMVResultsBody = props => {
  const {
    original_imv_price,
    priceAdjustmentTypeID_selected,
    priceAdjustmentHistory,
    priceAfterAdjustment,
    adPriced_lastIMV,
    updatedon_initIMV = 'Not available',
    updatedon_lastIMV = 'Not available'
  } = props.data;

  const renderedRows = useMemo(
    () =>
      IMV_RESULTS_KEYS.map(({ label, key }, index) => {

        const initKey = `${key}_initIMV`;
        const lastKey = `${key}_lastIMV`;

        if (!Object.hasOwn(props.data, initKey) || !Object.hasOwn(props.data, lastKey)) return null;

        const initValue = props.data[initKey];
        const lastValue = props.data[lastKey];

        return (
          <Row key={`${key}-${index}`} className={styles.row}>
            <Col>{label}</Col>
            <Col>{Object.hasOwn(props.data, initKey) ? isNumber(initValue) ? formatDollar(initValue, {currencySign: 'accounting'}) : initValue : '-'}</Col>
            <Col>{Object.hasOwn(props.data, lastKey) ? isNumber(lastValue) ? formatDollar(lastValue, {currencySign: 'accounting'}) : lastValue : '-'}</Col>
          </Row>
        );
      }),
    [props]
  );

  // RENDER
  return (
    <Form.Body>
      <Form.Col>
        <div className={styles.table}>
          <Row className={clsx(styles.row, styles.head)}>
            <Col></Col>
            <Col>Initial IMV</Col>
            <Col>Last IMV</Col>
          </Row>
          {renderedRows}
        </div>
      </Form.Col>
      {(updatedon_initIMV !== 'Not available' || updatedon_lastIMV !== 'Not available') && (
        <PriceAdjustment
          imvPrice={isString(original_imv_price) ? parseInt(original_imv_price.replaceAll(/[^\d.-]/g, ''), 10) : 0}
          adjustmentType={priceAdjustmentTypeID_selected || 1}
          history={priceAdjustmentHistory || []}
          priceAfterAdjustment={
            isString(priceAfterAdjustment)
              ? parseInt(priceAfterAdjustment.replaceAll(/[^\d.-]/g, ''), 10)
              : priceAfterAdjustment || 0
          }
          originalPrice={
            isString(adPriced_lastIMV)
              ? parseInt(adPriced_lastIMV.replaceAll(/[^\d.-]/g, ''), 10)
              : adPriced_lastIMV || 0
          }
        />
      )}
    </Form.Body>
  );
};

// EXPORT
export default function IMVResults(props) {
  return !checkRole(['dslAdmin', 'salesManagerPlus']) ? null :<Card title="IMV Results" body={<IMVResultsBody {...props} />} />;
}
